import { useState } from 'react';
import type { PackageResponse } from '../../types/packages';
import { formatAed, formatDay } from '../offers/offerReviewModel';
import { pick, PREVIEW_TEXT, PreviewLocale } from './packagePreviewText';

export interface PackagePreviewCardProps {
  pkg: PackageResponse;
  garageName: string;
  locale: PreviewLocale;
}

/**
 * The package tile on the garage profile. FIXED: struck original total, the package price and an
 * "Ends" pill when the package has an end date. PERCENT: "from AED X" and a "-N%" pill.
 */
export default function PackagePreviewCard(props: PackagePreviewCardProps) {
  const { pkg, garageName, locale } = props;
  const t = PREVIEW_TEXT[locale];
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const coverUrl = pkg.cover?.downloadUrl ?? null;
  const showImage = !!coverUrl && failedUrl !== coverUrl;
  const fixed = pkg.pricingMode === 'FIXED';

  return (
    <div className="offer-card package-card" data-testid="package-preview-card">
      {showImage ? (
        <img className="offer-card__banner" src={coverUrl!} alt="" onError={() => setFailedUrl(coverUrl)} />
      ) : (
        <div className="offer-card__banner offer-card__banner--fallback" />
      )}
      <div className="offer-card__scrim" />
      <div className="offer-card__content">
        {fixed && pkg.endsAt && (
          <span className="offer-card__badge" data-testid="package-pill-ends">{t.ends} <span dir="ltr">{formatDay(pkg.endsAt)}</span></span>
        )}
        {!fixed && pkg.discountPercent != null && (
          <span className="offer-card__badge" dir="ltr" data-testid="package-pill-percent">-{pkg.discountPercent}%</span>
        )}
        <div className="offer-card__title">{pick(locale, pkg.nameEn, pkg.nameAr)}</div>
        <div className="offer-card__price" data-testid="package-preview-price">
          {fixed ? (
            <span dir="ltr">
              <s>{formatAed(pkg.originalTotal)}</s> <strong>{formatAed(pkg.packagePrice)}</strong>
            </span>
          ) : (
            <span>
              {t.from} <strong dir="ltr">{formatAed(pkg.fromPrice)}</strong>
            </span>
          )}
        </div>
        <div className="offer-card__garage">{garageName}</div>
      </div>
    </div>
  );
}
